import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { Gtp } from 'src/app/shared/gtp';
import { Subscription } from 'rxjs';

import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { PageEvent } from '@angular/material/paginator';

import { GruposReferenciasService } from 'src/app/services/admin/grupos-referencias/grupos-referencias.service';
import { PuntosService } from 'src/app/shared/services/puntos-service/puntos.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-grupos-referencias-tabla',
  templateUrl: './grupos-referencias-tabla.component.html',
  styleUrls: ['./grupos-referencias-tabla.component.scss'],

})
export class GruposReferenciasTablaComponent implements OnInit, AfterViewInit {
  //@ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  //@ViewChild(MatSort, { static: true }) sort: MatSort; 
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort; 
  pageEvent: PageEvent;

  @Output() statusTabla = new EventEmitter();
  
    //TABLA
    public ELEMENT_DATA = [];
    public filter: any = {
      id : null,
      descripcion : '',
      observacion: '',
      opciones: null,
      buscar: '',
      orderby: 'id',
      sortby: 'asc',
      pageIndex: 0,
      pageSize: 10,
    };
    public contClass: string = 'container-fluid maincont';
    public dataSource: MatTableDataSource<any>;

    public tableCount;
    public loading: boolean = false;  
    public tableDisplay : Boolean = false;

    displayedColumns: string[] = [ 'id', 'descripcion', 'observacion', 'opciones'];
    //filtroForm : Subscription;
    
    constructor(
      private gtp: Gtp,
      private cdRef:ChangeDetectorRef,
      private apiCall: GruposReferenciasService,
      private puntosCall:PuntosService

    ) { 
      
      this.loadInforme()
    }
    
    ngOnInit(): void {
      this.getCargarTabla()

    }
    
    ngAfterViewInit() {
      //this.dataSource.sort = this.sort;
      //this.dataSource.paginator = this.paginator;
      
    }

  ngAfterViewChecked() {
    this.cdRef.detectChanges();
  }

  ngOnDestroy() {
  }

  loadInforme(){
    this.loading = true;
    this.puntosCall.getGrupos(false).subscribe(res => {
      this.apiCall.setContenidoTabla(res)
    });

  }
  
  getCargarTabla(){
    this.apiCall.getContenidoTablaObs().subscribe(res => {
      //console.log(res)
      this.dataSource = new MatTableDataSource(res);
      //console.log(this.dataSource)

      this.tableCount = res.length;
      this.dataSource.sort = this.sort;
      this.dataSource.paginator = this.paginator;
      
      this.loading = false;
      this.tableDisplay = true;
    });
  }


  containerSize(){
    this.contClass = this.gtp.containerSize(this.contClass);
  }

  cerrarTabla(){
    this.gtp.cerrarVentanas(true);    
  }

  setSort(event?) {
    this.filter.orderby = event.active;
    this.filter.sortby = event.direction;
    //this.loadInforme();
  }

  setPagination(event?) {
    this.filter.pageIndex = parseInt(event.pageIndex);
    this.filter.pageSize = parseInt(event.pageSize);
    //this.loadInforme();
    return event;
  }

  getPageSizeOptions(): number[] {    
    return [10, 20, this.tableCount];
  }

  applyFilter() {
    this.dataSource.filter = this.filter.buscar.trim().toLowerCase();
  }

  toggleEditar(el){
    // console.log(el)
    this.apiCall.setFormData(el);

  }

  toggleEliminar(el){
    console.log(el)
    Swal.fire({
      title: 'Atención!, Esta Seguro de Eliminar?',
      text: 'ID: '+ el.id+ ' Descripción: '+ el.descripcion,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Si, Borrar!'
    }).then((result) => {
      if (result.isConfirmed) {
        this.apiCall.deleteGruposReferencias(el.id).subscribe(res => {
          this.apiCall.setContenidoTabla( []); 
          Swal.fire(
            'Buen Trabajo!',
            'El punto fue eliminado correctamente',
            'success'
          )

        }, function(error){
          Swal.fire(
            'Epa..!',
            error,
            'error'
          )
        });
      }

      setTimeout(() => {
        this.loadInforme()
      }, 2000);
    })


  }
  
}

export interface DataTableGroup {
  id: number;
  cliente_id:string,
  descripcion: number;
  observacion: string;
  
}
